<template>
  <div class="ui negative message small">
    <div v-for="error in localisedErrors" v-html="error" :key="error"/>
  </div>
</template>

<script>

export default {
  name: 'ErrorMessages',
  props: {
    errors: {
      type: Array,
      required: false,
      default: () => {
        return []
      }
    }
  },
  computed: {
    localisedErrors () {
      return this.errors.map(error => {
        return this.localisation.error[error]
      })
    }
  }
}

</script>
